import { CommingSoon } from "./CommonComponents/ComingSoon";
import SalesOrderDashboard from "./components/Dashboard/SalesOrderDashboard";
import Dashboard from "./components/HomePage/Dashboard";
import LeadDashboard from "./components/HomePage/LeadDashboard";
import QuotationDashboard from "./components/HomePage/QuotationDashboard";
import LeadEntry from "./components/Lead/LeadEntry";
import LeadEntryFollowUpDetails from "./components/Lead/LeadEntryFollowUp";
import LeadEntryReport from "./components/Lead/LeadEntryReport";
import LogReport from "./components/Lead/LogReport";
import PendingFollowUpLead from "./components/Lead/PendingFollowUpLead";
import PendingFollowUpLeadEntry from "./components/Lead/PendingFollowUpLeadEntry";
import ReassignLead from "./components/Lead/ReassignLead";
import ChangePassword from "./components/UserSection/ChangePassword";
import UserGroupMaster from "./components/UserSection/GroupMaster";
import GroupMenuAccess from "./components/UserSection/GroupMenuAccess";
import ResetPassword from "./components/UserSection/ResetPassword";
import UserGroupAccess from "./components/UserSection/UserGroupAccess";
import UserLogReport from "./components/UserSection/UserLogReport";
import UserMaster from "./components/UserSection/UserMaster";
import UserMenuAccess from "./components/UserSection/UserMenuAccess";

const AppRoutes = [
    {
        path: '*',
        element: CommingSoon
    },
    {
        path: '/User/UserMaster',
        element: UserMaster
    },
    {
        path: '/User/UserGroupMaster',
        element: UserGroupMaster
    },
    {
        path: '/User/ChangePassword',
        element: ChangePassword
    },
    {
        path: '/User/ResetPassword',
        element: ResetPassword
    },
    {
        path: '/User/GroupMenuAccess',
        element: GroupMenuAccess
    }, {
        path: '/Dashboard/Dashboard',
        element: Dashboard
    }, {
        path: '/User/UserLogReport',
        element: UserLogReport
    }, {
        path: '/User/UserMenuAccess',
        element: UserMenuAccess
    }, {
        path: '/User/UserGroupAccess',
        element: UserGroupAccess
    },
    {
        path: '/LeadEntry/LeadEntryReport',
        element: LeadEntryReport
    },
    {
        path: '/LeadEntry/PendingFollowUpLeadEntry',
        element: PendingFollowUpLeadEntry
    },
    {
        path: '/LeadEntry/PendingFollowUpLead',
        element: PendingFollowUpLead
    },
    {
        path: '/LeadEntry/LeadEntry',
        element: LeadEntry
    },
    {
        path: '/LeadEntry/LogReport',
        element: LogReport
    },
    {
        path: '/LeadEntry/ReassignLead',
        element: ReassignLead
    },
   
    {
        path: '/LeadEntry/LeadEntryFollowUp',
        element: LeadEntryFollowUpDetails
    },
   
   
    {
        path: '/Dashboard/LeadDashboard',
        element: LeadDashboard
    },
    {
        path: '/Dashboard/QuotationDashboard',
        element: QuotationDashboard
    },
   
    
    {
        path: '/Dashboard/SalesOrderDashboard',
        element: SalesOrderDashboard
    },
  
];

export default AppRoutes;
